import styled, {css} from "styled-components"

interface LoaderWrapperProps {
  isPanoramaPost: boolean,
  isMobile: boolean,
  isLoadingIframeData: boolean
}

export const LoaderWrapper = styled.div<LoaderWrapperProps>`
  top: 0;
  left: 0;
  position: absolute;
  display: ${props => props.isLoadingIframeData ? 'none' : 'flex'} ;
  justify-content: center;
  align-items: center;
  border-radius: ${props => props.isPanoramaPost ? '0 0 16px 16px' : '0 0 10px 10px'};
  width: 100%;
  height: calc(100% + 2px);
  background: rgba(29, 37, 45, .6);
  
  ${props => props.isMobile && css`
    border-radius: 0;
  `}
`
